import { IAbortController } from './AbortController';
export type Method =
    | 'get'
    | 'GET'
    | 'delete'
    | 'DELETE'
    | 'head'
    | 'HEAD'
    | 'options'
    | 'OPTIONS'
    | 'post'
    | 'POST'
    | 'put'
    | 'PUT'
    | 'patch'
    | 'PATCH'
    | 'purge'
    | 'PURGE'
    | 'link'
    | 'LINK'
    | 'unlink'
    | 'UNLINK';

type CommonResponseHeadersList =
    | 'Server'
    | 'Content-Type'
    | 'Content-Length'
    | 'Cache-Control'
    | 'Content-Encoding';
export type HeaderValue = string | string[] | number | boolean | null;

interface RawHeaders {
    [key: string]: HeaderValue;
}
type RawCommonResponseHeaders = {
    [Key in CommonResponseHeadersList]: HeaderValue;
} & {
    'set-cookie': string[];
};
export type HttpClientHeaders = RawCommonResponseHeaders | RawHeaders;

export interface IRequestOptionsBase {
    headers?: HttpClientHeaders;
    params?: any;
    abortController?: IAbortController;
}

export interface IRequestOptions<TData> extends IRequestOptionsBase {
    url: string;
    method: Method | string;
    headers?: HttpClientHeaders;
    data?: TData;
    params?: any;
}

export interface IRequestResult<T> {
    data: T;
    headers: HttpClientHeaders;
    status: number;
}

export interface IHttpClient {
    get<TResult>(url: string, options?: IRequestOptionsBase): Promise<IRequestResult<TResult>>;
    post<TResult, TData = any>(
        url: string,
        data: TData,
        options?: IRequestOptionsBase,
    ): Promise<IRequestResult<TResult>>;
    put<TResult, TData = any>(
        url: string,
        data: TData,
        options?: IRequestOptionsBase,
    ): Promise<IRequestResult<TResult>>;
    delete<TResult>(url: string, options?: IRequestOptionsBase): Promise<IRequestResult<TResult>>;
    request<TResult, TData = any>(config: IRequestOptions<TData>): Promise<IRequestResult<TResult>>;
}

export class HttpClientError extends Error {
    constructor(
        public code?: string,
        message?: string,
        public responseHeaders?: HttpClientHeaders,
        public isAborted?: boolean,
        public status?: number,
    ) {
        super(message ?? 'HTTP request failed');
        this.message = message ?? 'HTTP request failed';
        this.isAborted = isAborted ?? false;
    }
}
